import type { UserAssetV2Record } from "@apis/http/api";
import { ImagePreviewCard } from "@components/MediaPreview";
import { Checkbox } from "@kalodata/kds-design";
import { useHover } from "ahooks";
import { useRef } from "react";
import { twMerge } from "tailwind-merge";

interface UIImageCardProps {
  record: UserAssetV2Record;
  onRefresh?: () => void;
  selected?: boolean;
  onSelectedChange?: (selected: boolean) => void;
}

export const UIImageCard = ({ record, onRefresh, selected = false, onSelectedChange }: UIImageCardProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isHovered = useHover(ref);
  const showCheckbox = selected || isHovered;

  return (
    <div ref={ref} className="kalo-white-card relative flex w-full flex-col overflow-hidden p-0!">
      <Checkbox
        checked={selected}
        onCheckedChange={(checked) => onSelectedChange?.(checked === true)}
        className={twMerge(
          "absolute left-[12px] top-[12px] z-1",
          "size-4 shrink-0 rounded-[4px] shadow-sm",
          "border-0 bg-kds-mask",
          "data-[state=checked]:border-kds-accent data-[state=checked]:bg-kds-accent data-[state=checked]:text-kds-light",
          "data-[state=checked]:**:data-[slot=checkbox-indicator]:grid!",
          "data-[state=checked]:[&_[data-slot=checkbox-indicator]_svg]:size-3",
          "cursor-pointer disabled:cursor-not-allowed disabled:opacity-40",
          showCheckbox ? "inline-flex" : "hidden",
        )}
        onClick={(event) => event.stopPropagation()}
        onPointerDown={(event) => event.stopPropagation()}
      />
      <ImagePreviewCard
        src={record.url}
        assetId={record.id}
        onDeleted={onRefresh}
        className="aspect-square shrink-0 rounded-none"
      />
    </div>
  );
};
